import { useEffect } from "react";
import { useBreadcrumbContext } from "../contexts/BreadcrumbProvider/BreadcrumbProvider";
import { IBreadcrumbProps } from "../layout/fullLayout/breadcrumb/IBreadcrumbProps";

export const useBreadcrumb = (options: IBreadcrumbProps) => {
  const { addBreadcrumb, removeBreadcrumb } = useBreadcrumbContext();

  useEffect(() => {
    addBreadcrumb(options);
    return () => {
      removeBreadcrumb();
    };
  }, [options.title]);
};
